export default function loginDirective() {
  return {
    template: require('./login.html'),
    scope: {},
    controller: 'LoginController',
    controllerAs: 'loginVM',
    bindToController: true,
    replace: true,
  };
}
